const AlignedTextLeft = () => (
  <>
    <path
      fill="currentColor"
      d="M5.5 17.27a.48.48 0 0 1-.356-.145.49.49 0 0 1-.144-.357q0-.212.144-.355a.49.49 0 0 1 .356-.144h9q.213 0 .356.144a.48.48 0 0 1 .144.357q0 .212-.144.356a.48.48 0 0 1-.356.143zm0-4.77a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.357q0-.212.144-.356A.49.49 0 0 1 5.5 11.5h5q.212 0 .356.144a.49.49 0 0 1 .144.357q0 .213-.144.356a.48.48 0 0 1-.356.143zm0-4.77a.48.48 0 0 1-.356-.143A.48.48 0 0 1 5 7.23q0-.213.144-.356a.49.49 0 0 1 .356-.143h13q.212 0 .356.144A.49.49 0 0 1 19 7.23q0 .213-.144.356a.48.48 0 0 1-.356.144z"
    />
  </>
)
export default AlignedTextLeft
